const getUserMedia = (constraints, onSuccess, onError) => {
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    return navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError).catch(onError);
  }
  if (typeof navigator.getUserMedia === 'function') {
    return navigator.getUserMedia(constraints, onSuccess, onError);
  }
  if (typeof navigator.webkitGetUserMedia === 'function') {
    return navigator.webkitGetUserMedia(constraints, onSuccess, onError);
  }
  if (typeof navigator.mozGetUserMedia === 'function') {
    return navigator.mozGetUserMedia(constraints, onSuccess, onError);
  }
  onError('INCOMPATIBLE_BROWSER');
};
export default function GetUserMedia(constraints) {
  return new Promise((resolve, reject) => {
    getUserMedia(constraints, resolve, reject);
  });
}
